<match-display-wrapper 
    matchLabel="{{ l10nKeys.authAttributeMatchLabel | vtranslate }}"
    subheader="{{ attributeName }}"
>
    <div *ngFor="let value of attributeValues; trackBy: trackByIndex">
        {{ value }}
    </div>
</match-display-wrapper>
